import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ApiResponseJson } from './json/api-response-json.model';

@Injectable({
  providedIn: 'root'
})
export class ApiRequestsService {

  local_test_mode: boolean = false; // FIXME: Set to false when working with backend

  token: string;
  //host: string = 'http://localhost:8000/';
  host: string = 'http://ec2-18-202-25-77.eu-west-1.compute.amazonaws.com/';

  routesToUrl = {
    'get-token': 'auth/get-token/',
    'check-token': 'auth/check-token/',
    'sign-in': 'auth/sign-in/',
    'register': 'auth/register/',
    'sign-out': 'auth/sign-out/',
    'user-infos': 'user/get-infos/',
    'user-picture': 'user/picture/',
    'currency-list': 'data/currency/list/',
    'investment-zone-list': 'data/investment-zone/list/',
    'benchmark-list': 'data/benchmark/list/',
    'product-list': 'data/product/list/',
    'peer-list': 'data/peer/list/',
    'peer-product': 'data/peer/product/',
    'create-original': 'data/create-original/',
    'create-standalone': 'data/create-standalone/',
    'create-default-strategies': 'data/create-default-strategies/',
    'cluster-list': 'data/cluster/list/',
    'get-cluster': 'data/cluster/',
    'get-original': 'data/original/',
    'get-strategy': 'data/strategy/',
    'get-investable': 'data/investable/',
    'get-protected': 'data/protected/',
    'get-benchmark': 'data/benchmark/',
    'default-strategies': 'data/default-strategies/',
    'delete-cluster': 'data/cluster/delete/',
    'custom-strategy': 'data/custom-strategy/',
    'insurance': 'data/insurance/',
    'monte-carlo': 'data/monte-carlo/',
    'custom-investable': 'data/custom-investable/',
    'compute-protected': 'data/compute-protected/',
    'update-cluster': 'data/cluster/update/',
    'create-watchlist': 'data/watchlist/create/',
    'list-watchlist': 'data/watchlist/list/',
    'delete-watchlist': 'data/watchlist/delete/',
    'cluster-report': 'data/cluster/report/',
  };

  private apiResponses: ApiResponseJson = new ApiResponseJson();

  constructor(private httpClient: HttpClient,
              private router: Router) {
    // Add host to the beginning of all URLS
    Object.keys(this.routesToUrl).forEach(
      (key) => {
        this.routesToUrl[key] = this.host + this.routesToUrl[key];
      }
    );
  }

  async startSession(username: string, password: string) {
    const inputs = {
      username: username,
      password: password
    };
    const data:any = await this.post('sign-in', inputs, false);
    this.token = data.token;

    return data;
  }

  async destroySession() {
    const data:any = await this.get('sign-out');
    this.token = undefined;

    return data;
  }

  hasToken(): boolean {
    return this.token!=undefined;
  }

  async checkToken(): Promise<boolean> {
    const data:any = await this.get('check-token');

    if (data.status!='OK') { // Invalid token
      this.router.navigate(['sign-in']);
    }

    return true;
  }

  get(route:string, addHeaders:boolean=true) {
    // PATCH TO WORK WITHOUT BACKEND
    if (this.local_test_mode) {
      if (addHeaders) {
        if (!this.token) {this.router.navigate(['sign-in']);}
      }
      return new Promise(
        (resolve, reject) => {
          resolve(this.apiResponses.getData(route));
        }
      );
    }
    // END PATCH

    if (addHeaders) {
      if (!this.token) {this.router.navigate(['sign-in']);}
      return new Promise(
        (resolve, reject) => {
          const headers = new HttpHeaders().set('Authorization', 'Token '+this.token);
          this.httpClient.get(this.routesToUrl[route], {headers}).pipe(
            catchError(this.handleError.bind(this))
          ).subscribe(
            (data:any) => {resolve(data);},
            (error) => {reject(error);}
          );
        }
      );
    } else {
      return new Promise(
        (resolve, reject) => {
          this.httpClient.get(this.routesToUrl[route]).subscribe(
            (data:any) => {resolve(data);},
            (error) => {reject(error);}
          );
        }
      );
    }
  }

  post(route:string, inputs:any, addHeaders:boolean=true) {
    // PATCH TO WORK WITHOUT BACKEND
    if (this.local_test_mode) {
      if (addHeaders) {
        if (!this.token) {this.router.navigate(['sign-in']);}
      }
      return new Promise(
        (resolve, reject) => {
          resolve(this.apiResponses.getData(route));
        }
      );
    }
    // END PATCH

    if (addHeaders) {
      if (!this.token) {this.router.navigate(['sign-in']);}
      return new Promise(
        (resolve, reject) => {
          const headers = new HttpHeaders().set('Authorization', 'Token '+this.token);
          this.httpClient.post(this.routesToUrl[route], inputs, {headers}).pipe(
            catchError(this.handleError.bind(this))
          ).subscribe(
            (data:any) => {resolve(data);},
            (error) => {reject(error);}
          );
        }
      );
    } else {
      return new Promise(
        (resolve, reject) => {
          this.httpClient.post(this.routesToUrl[route], inputs).subscribe(
            (data:any) => {resolve(data);},
            (error) => {reject(error);}
          );
        }
      );
    }
  }

  handleError(error: HttpErrorResponse) {
    console.log('HTTP ERROR: '+error.status+' '+error.statusText);
    console.log(error);
    if (error.status==401) { // Unauthorized
      this.router.navigateByUrl('sign-in');
    } else if (error.status==404) { // Not Found
      this.router.navigateByUrl('not-found');
    }
    return throwError(error);
  }

  open(route:string, inputs:any={}, target:string='_blank') {
    // Generation of input string
    let inputstr: string = '';
    Object.keys(inputs).forEach((key) => {
      inputstr += `&${key}=${inputs[key]}`
    });
    window.open(`${this.routesToUrl[route]}?token=${this.token}${inputstr}`, target);
  }

}
